import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;
let cancelRead;
class ScreenScheduleApi extends Api {
  constructor() {
    super('screen-schedules', 'screen-schedules');
  }

  async readData(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }

  async readWindowBreakdown(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    }, 'read-window-breakdown');
    return res;
  }
}
const screenScheduleApi = new ScreenScheduleApi();

export default screenScheduleApi;
